import { render, staticRenderFns } from "./DesignCard.vue?vue&type=template&id=6275edb6&"
import script from "./DesignCard.vue?vue&type=script&lang=js&"
export * from "./DesignCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports